var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewcustom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M127.276 166.569L143.717 181.183C146.543 183.695 150.926 183.179 153.092 180.082L177.687 144.904",
    stroke: "black",
    strokeWidth: 15,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M127.276 276.129L143.717 290.744C146.543 293.255 150.926 292.74 153.092 289.643L177.687 254.464",
    stroke: "black",
    strokeWidth: 15,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M127.276 384.217L143.717 398.831C146.543 401.343 150.926 400.827 153.092 397.73L177.687 362.552",
    stroke: "black",
    strokeWidth: 15,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M221.184 148.845H327.175",
    stroke: "black",
    strokeWidth: 15,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M221.184 182.176H327.175",
    stroke: "black",
    strokeWidth: 15,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M221.184 256.001H327.175",
    stroke: "black",
    strokeWidth: 15,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M221.184 289.332H274.179",
    stroke: "black",
    strokeWidth: 15,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M410.452 144.501V83.5543C410.452 74.4443 403.067 67.0603 393.958 67.0603H310.234",
    stroke: "black",
    strokeWidth: 15,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M144.216 67.0603H60.4908C51.3828 67.0603 43.9979 74.4453 43.9979 83.5543V488.006C43.9979 497.116 51.3828 504.5 60.4908 504.5H393.958C403.067 504.5 410.452 497.116 410.452 488.006V296.918",
    stroke: "black",
    strokeWidth: 15,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M259.897 31.1554C259.897 18.0915 249.306 7.5015 236.243 7.5015H218.206C205.142 7.5015 194.552 18.0915 194.552 31.1554C194.552 37.7824 189.179 43.1554 182.552 43.1554H168.12C154.918 43.1554 144.216 53.8574 144.216 67.0593V79.6173C144.216 85.8843 149.296 90.9633 155.562 90.9633H298.887C305.154 90.9633 310.234 85.8843 310.234 79.6173V67.0593C310.234 53.8574 299.532 43.1554 286.33 43.1554H271.897C265.269 43.1554 259.897 37.7824 259.897 31.1554Z",
    stroke: "black",
    strokeWidth: 15,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7038 67.0603V453.187C79.7038 459.196 84.5748 464.066 90.5837 464.066H202.241",
    stroke: "black",
    strokeWidth: 15,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M374.747 189.157V67.0593",
    stroke: "black",
    strokeWidth: 15,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M265.336 463.84L234.201 464.065H363.867C369.876 464.065 374.747 459.194 374.747 453.186V341.375",
    stroke: "black",
    strokeWidth: 15,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M399.444 197.631L229.288 409.932L202.24 464.246C201.175 466.387 200.874 468.829 201.389 471.165C201.903 473.501 203.201 475.59 205.067 477.086C206.933 478.582 209.255 479.394 211.647 479.387C214.039 479.381 216.356 478.556 218.214 477.05L265.336 438.823L435.491 226.523",
    stroke: "black",
    strokeWidth: 15,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M265.769 438.692L229.522 409.64",
    stroke: "black",
    strokeWidth: 15,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M459.348 159.825C449.394 151.846 434.857 153.448 426.878 163.403L399.445 197.632L435.492 226.523L462.926 192.294C470.904 182.34 469.302 167.803 459.348 159.825Z",
    stroke: "black",
    strokeWidth: 15,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewcustom);
export default __webpack_public_path__ + "static/media/newcustom.20d55094a1ce12c533d4655ef2070f19.svg";
export { ForwardRef as ReactComponent };